import { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { countryProductId, profileTypeEndPoint } from "../../components/templates/Profile/ProfileHeader/profile-enum";
import { getRemainingValueAddCredits } from "../../core/utility/utility";
import CompanyContacts from "@routes/intel/us/company-profile/CompanyContacts";
import { useDispatch, useSelector } from "react-redux";
import { getCreditsByPlanHandler, getUserProfileHandler } from "@redux/User/userDetails.action";

const ContactDetails = ({ countDetails, eventEnum, profileType, isSalesForce }) => {
  const [deparmentDropdownClose, setDeparmentDropdownClose] = useState(false);
  const [managementDropdownClose, setManagementDropdownClose] = useState(false);
  const [locationClose, setLocationClose] = useState(false);
  const [userCredit, setUserCredit] = useState(null);
  const [valueAddCredit, setValueAddCredit] = useState(null);
  const [creditsLoading, setCreditsLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const hasGlobalPlan = creditDetails?.data?.some((plan) => plan?.is_active && plan?.user_active_plan?.toLowerCase()?.includes("global")) ?? false;
  const { portId, portName } = useParams();

  const { name, companyId } = countDetails;
  const { search: searchUrlParams } = location;
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const countryName = new URLSearchParams(location.search).get("country");
  const getUserPlan = useCallback(() => {
    setCreditsLoading(true);
    const params = {
      product_id: hasGlobalPlan && (!countryName || countryName === "multicountry") ? countryProductId["global data"] : (countryProductId[countryName] ?? countryProductId["us"]),
    };
    axios
      .get(profileTypeEndPoint.getUserPlanDetails, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.data && !!res.data.data.length > 0) {
          if (!res.data.data[0].user_active_plan) res.data.data[0].user_active_plan = "";
          setUserCredit(res.data.data[0]);
          // Same number the contacts-search response returns as
          // remaining_value_add_credit, so the count no longer jumps when that
          // call lands.
          const remainingValueAdd = getRemainingValueAddCredits(res.data.credit_details);
          if (remainingValueAdd !== null) {
            setValueAddCredit(remainingValueAdd);
          }
          if (res?.data?.isUpdated) {
            dispatch(getUserProfileHandler({ isUpdated: true }));
            dispatch(getCreditsByPlanHandler());
          }
        } else {
          toast.error("Something went wrong! Please try again.");
        }
      })
      .catch(() => {
        toast.error("Could not load your credit details. Please refresh the page.");
      })
      .finally(() => {
        setCreditsLoading(false);
      });
  }, [location, hasGlobalPlan]);

  useEffect(() => {
    getUserPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portId, portName, hasGlobalPlan]);

  return (
    <CompanyContacts
      deparmentDropdownClose={deparmentDropdownClose}
      managementDropdownClose={managementDropdownClose}
      locationClose={locationClose}
      setLocationClose={() => setLocationClose(false)}
      setDeparmentDropdownClose={(val) => setDeparmentDropdownClose(val)}
      setManagementDropdownClose={(val) => setManagementDropdownClose(val)}
      data={{
        companyData: {
          name: name || countDetails?.companyName || "",
          id: companyId,
        },
        companyAddress: countryName,
        valueAddCredit: valueAddCredit ?? 0,
        creditsLoading: creditsLoading,
        companyName: "",
      }}
      setValueAddCredit={setValueAddCredit}
      userCredit={userCredit}
      dataSource={dataSource}
      pathName={location.pathname}
      profileType={profileType}
      currentUserPlan={userCredit ? userCredit.user_active_plan : ""}
      eventName={eventEnum}
      isSalesForce={isSalesForce}
    />
  );
};

export default ContactDetails;
